import React, { useState } from 'react';
import logo from '../assets/LinkedIn-Local-Cameroon-Logo.svg';

const links = ['Home', 'About', 'Schedule', 'Speakers', 'Gallery', 'Tickets'];

export default function Navbar() {
  const [active, setActive] = useState('Home');
  const [menuOpen, setMenuOpen] = useState(false);

  const handleLink = (link) => {
    setActive(link);
    setMenuOpen(false);
  };

  return (
    <nav className="navbar">
      <div className="container">
        <div className="navbar__inner">
          <a href="#home" className="navbar__logo">
            <img src={logo} alt="LinkedIn Local Cameroon" className="navbar__logo-img" />
          </a>
          <ul className={`navbar__links${menuOpen ? ' navbar__links--open' : ''}`}>
            {links.map((link) => (
              <li key={link}>
                <a
                  href={`#${link.toLowerCase()}`}
                  className={active === link ? 'active' : ''}
                  onClick={() => handleLink(link)}
                >
                  {link}
                </a>
              </li>
            ))}
            <li className="navbar__mobile-cta">
              <a href="#tickets" className="btn-primary" onClick={() => setMenuOpen(false)}
                style={{ fontSize: '13px', padding: '8px 20px', width: '100%', justifyContent: 'center' }}>
                Register ↗
              </a>
            </li>
          </ul>
          <a href="#tickets" className="btn-primary navbar__desktop-cta" style={{ fontSize: '13px', padding: '8px 20px' }}>
            Register ↗
          </a>
          <button
            className={`navbar__hamburger${menuOpen ? ' navbar__hamburger--open' : ''}`}
            onClick={() => setMenuOpen((o) => !o)}
            aria-label="Toggle menu"
            type="button"
          >
            <span /><span /><span />
          </button>
        </div>
      </div>
      {menuOpen && <div className="navbar__overlay" onClick={() => setMenuOpen(false)} />}
    </nav>
  );
}
